// extracted by mini-css-extract-plugin
export default {"reportContainer":"Report_reportContainer__rv0mc"};